const firebaseConfig = {
  apiKey: 'AIzaSyBLgHFNKm0cNp_tKNEyNdc8fKiv9hxfk_M',
  authDomain: 'pixelunit-bb220.firebaseapp.com',
  databaseURL: 'https://pixelunit-bb220.firebaseio.com',
  projectId: 'pixelunit-bb220',
  storageBucket: 'pixelunit-bb220.appspot.com',
  messagingSenderId: '794899407773',
  appId: '1:794899407773:web:0404b12f538eaa075b4574',
  measurementId: 'G-E0SH51T0Q5'
}

export default firebaseConfig
